/**
 * SAP PDP Gallery Overrides — mobile thumbnail strip (2026) + legacy dots
 * Polls for Embla initialisation up to 3 s, then inserts BOTH affordances:
 *   - .sap-gallery-thumbs (2026 default — tappable image thumbnails)
 *   - .sap-gallery-dots   (legacy, shown only when the review toggle panel
 *     sets body.sap-off-pdp-gallery-2026; CSS decides visibility)
 * Inline script is forbidden per convention; the section references this file.
 */
(function () {
  'use strict';

  var MAX_WAIT_MS = 3000;
  var POLL_INTERVAL_MS = 100;

  function wireSelection(embla, items, scrollOnClick) {
    items.forEach(function (item, index) {
      if (scrollOnClick) {
        item.addEventListener('click', function () {
          embla.scrollTo(index);
        });
      }
    });

    function update() {
      var active = embla.selectedScrollSnap();
      items.forEach(function (item, idx) {
        var isActive = idx === active;
        item.setAttribute('aria-current', isActive ? 'true' : 'false');
        item.setAttribute('tabindex', isActive ? '0' : '-1');
        item.classList.toggle('is-active', isActive);
      });
    }

    embla.on('select', update);
    update();
  }

  function buildThumbs(carouselEl, embla) {
    var slides = carouselEl.querySelectorAll('.carousel__slide');
    if (!slides || slides.length < 2) return;

    var strip = document.createElement('div');
    strip.className = 'sap-gallery-thumbs';
    strip.setAttribute('role', 'tablist');
    strip.setAttribute('aria-label', 'Gallery images');

    var thumbs = [];
    slides.forEach(function (slide, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sap-gallery-thumbs__thumb';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + slides.length);

      var img = slide.querySelector('img');
      if (img) {
        var thumbImg = document.createElement('img');
        /* currentSrc gives the responsive candidate the browser actually chose;
           src is the safe fallback before the hero has loaded. */
        thumbImg.src = img.currentSrc || img.src;
        thumbImg.alt = '';
        thumbImg.loading = 'lazy';
        btn.appendChild(thumbImg);
      }

      strip.appendChild(btn);
      thumbs.push(btn);
    });

    carouselEl.parentNode.insertBefore(strip, carouselEl.nextSibling);
    wireSelection(embla, thumbs, true);
  }

  function buildDots(carouselEl, embla) {
    var count = embla.scrollSnapList().length;
    if (count < 2) return;

    var strip = document.createElement('div');
    strip.className = 'sap-gallery-dots';
    strip.setAttribute('role', 'tablist');
    strip.setAttribute('aria-label', 'Gallery images');

    var dots = [];
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'sap-gallery-dots__dot';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + count);
      (function (index, el) {
        el.addEventListener('click', function () {
          embla.scrollTo(index);
        });
      })(i, dot);
      strip.appendChild(dot);
      dots.push(dot);
    }

    carouselEl.parentNode.insertBefore(strip, carouselEl.nextSibling);
    wireSelection(embla, dots, false);
  }

  /* Desktop hero-fit backdrop: a blurred clone of the hero image fills the
     5:4 frame behind the contained original (see the section's stylesheet).
     Skipped for video heroes — those keep object-fit: cover. */
  function buildHeroBackdrop() {
    var item = document.querySelector(
      '.product-desktop-media .product-media-grid .product-media-grid__item:first-child'
    );
    if (!item || item.querySelector('.sap-hero-backdrop')) return;

    var img = item.querySelector('img');
    if (!img) return;

    var clone = document.createElement('img');
    clone.className = 'sap-hero-backdrop';
    clone.alt = '';
    clone.setAttribute('aria-hidden', 'true');
    clone.src = img.currentSrc || img.src;
    if (!clone.src) {
      img.addEventListener(
        'load',
        function () {
          clone.src = img.currentSrc || img.src;
        },
        { once: true }
      );
    }
    item.insertBefore(clone, item.firstChild);
  }

  function pollForEmbla() {
    var mobileMedia = document.querySelector('.product-mobile-media');
    if (!mobileMedia) return;

    var carouselEl = mobileMedia.querySelector('carousel-component');
    if (!carouselEl) return;

    var elapsed = 0;
    var timer = setInterval(function () {
      elapsed += POLL_INTERVAL_MS;

      var embla = carouselEl.embla;
      if (embla && embla.scrollSnapList && embla.scrollSnapList().length > 1) {
        clearInterval(timer);
        buildThumbs(carouselEl, embla);
        buildDots(carouselEl, embla);
        return;
      }

      if (elapsed >= MAX_WAIT_MS) {
        clearInterval(timer);
        /* Embla never became ready — bail gracefully; no affordances rendered */
      }
    }, POLL_INTERVAL_MS);
  }

  function init() {
    buildHeroBackdrop();
    pollForEmbla();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
